import { render, staticRenderFns } from "./CollectionBreadcrumbs.vue?vue&type=template&id=14051fec&scoped=true&lang=pug&"
import script from "./CollectionBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./CollectionBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./CollectionBreadcrumbs.vue?vue&type=style&index=0&id=14051fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14051fec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14051fec')) {
      api.createRecord('14051fec', component.options)
    } else {
      api.reload('14051fec', component.options)
    }
    module.hot.accept("./CollectionBreadcrumbs.vue?vue&type=template&id=14051fec&scoped=true&lang=pug&", function () {
      api.rerender('14051fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionBreadcrumbs.vue"
export default component.exports